<template>
    <div class="download-list">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="downloadList"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder = "inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div :class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    align="center"
                ></el-table-column>
                <el-table-column
                    align="center"
                    width="100"
                    :label="$t('downloadList.tableName.goodsImg')"
                >
                    <template slot-scope="scope">
                        <el-image
                            class="elImage_show"
                            style="height: 80px; width: 80px"
                            fit="fill"
                            :src="ossImg(scope.row.goods.goods_images[0], 80, 80)"
                            :preview-src-list="scope.row.goods.goods_images.map(img => ossImg(img, 800, 800))"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                            <div slot="placeholder" class="image-slot">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    property="goods_name"
                    align="left"
                    :label="$t('downloadList.tableName.goodsInfo')"
                >
                    <template slot-scope="scope">
                        <div class="tbItem">
                            <div
                                class="goods-name ellipsis-2"
                                @click="toGoodsDetail(scope.row)"
                            >
                                {{ scope.row.goods.goods_name }}
                            </div>
                            <div>SPU:&nbsp;{{ scope.row.goods.spu }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="SKU"
                    prop="sku_qty"
                    width="120"
                >
                    <template slot-scope="scoped">
                        <el-popover
                            placement="right"
                            width="800"
                            trigger="hover">
                            <el-table :data="scoped.row.sku_list">
                                <el-table-column width="150" property="sku" label="SKU"></el-table-column>
                                <el-table-column width="300" property="value" label="Attribute" show-overflow-tooltip></el-table-column>
                                <el-table-column width="100" property="weight" label="Weight(g)"></el-table-column>
                                <el-table-column width="150" property="stock" label="Inventory">
                                    <template slot-scope="sco">
                                        <div v-if="sco.row.delivery_type == 2">Made to order</div>
                                        <div v-else>{{ sco.row.stock }} (
                                            <span v-if="sco.row.differ > 0">+{{ sco.row.differ }}</span>
                                            <span style="color:red" v-else-if="sco.row.differ < 0">{{ sco.row.differ }}</span>
                                            <span v-else>{{ sco.row.differ }}</span>
                                            )</div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" property="price" label="Price">
                                    <template slot-scope="scoped">
                                        ${{ scoped.row.price }}
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button type="text" slot="reference">{{scoped.row.sku_qty}} Sku</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Shop"
                    prop="shop_name"
                    width="150"
                ></el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('downloadList.tableName.category_name')"
                    prop="goods.goods_category.name_en"
                    width="150"
                >
                    <template slot-scope="scoped">
                        <div
                            v-for="item of scoped.row.catalog_names"
                            :key="item.name"
                        >
                            {{ item.name_en }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    align="left"
                    :label="$t('downloadList.tableName.download_time')"
                    prop="created_at"
                    width="150"
                ></el-table-column>
                <el-table-column label="Operation" align="left" width="200">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <generate :generateVisible.sync="generateVisible"></generate>
    </div>
</template>
<script>
import axios from "axios";
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import util from "@/utils/util.js";
import { tableMixins } from "@/utils/tableMixins.js";
import generate from "@/common/components/generateDialog.vue";
export default {
    // 有些表格的相同部分 , 抽离在了tableMixins混合器里面
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Product Name、SPU、SKU",
            searchForm: {},
            searchForm_transfer: {},
            funcName: "downloadList",
            detailVisible: false,
            selectList: [],
            advanceSearchFields: {
                shop_id: {
                    label: "Shop",
                    type: "select",
                    options: [],
                },
            },
            generateVisible: false,
            ossImg: util.ossImg
        };
    },
    methods: {
        /**
         * 产品新增
         */
        add() {
            this.addVisible = true;
        },
        download(item) {
            /* axios(
                `${process.env.VUE_APP_BASE_API}/sale/goodsDownload/down/${item.id}`,
                {
                    responseType: "blob",
                    headers: {
                        authorization: `Bearer ${localStorage.getItem(
                            "token"
                        )}`,
                    },
                }
            ).then((res) => {
                // console.log(res);
                const blob = new Blob([res.data], {
                    type: "application/zip",
                }); // new一个二进制对象
                const url = window.URL.createObjectURL(blob); // 转化为url
                const link = document.createElement("a"); // 创建个a标签
                link.href = url;
                link.click();
                URL.revokeObjectURL(url);
            }); */
            cmofferApi.goodsDownload({}, "get", item.id).then((res) => {
                if (res.errcode == 0) {
                    this.generateVisible = true;
                }
            });
        },
        // 获取下载列表
        downloadList(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .downloadList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.closeDrawer();
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        shopSelect() {
            cmofferApi.shopSelect({user_id:1}, "get").then((res) => {
                if (res) {
                    this.advanceSearchFields.shop_id.options = res.data.map(item=>{
                        return {
                            label: item.name,
                            value: item.id
                        }
                    });
                }
            });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                if (item.funcName == "detail") {
                    this.toGoodsDetail(row);
                } else if (item.funcName == "edit") {
                    this.editVisible = true;
                    this.tableItem = row;
                } else if (item.funcName == "download") {
                    this.download(row);
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.downloadList();
            await this.shopSelect();
        },
        // 跳转到商品详情
        toGoodsDetail(item) {
            // this.$router.push({
            //     path: `/goodsList/detail`,
            //     query: {
            //         id: item.goods_id,
            //     },
            // });
            window.open('/goodsList/detail?id='+item.goods_id, "_blank");
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        generate,
    },
    computed: {},
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.download-list {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
    .goods-name {
        color: $color-333333;
        font-weight: bold;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
    .font-bold {
        font-weight: bold;
    }
}
</style>
